import { Routes, Route, Navigate } from 'react-router';
import appConfig from '@/configs/app.config';
import { protectedRoutes, publicRoutes } from '@/configs/routes.config';
import PageContainer from '@/components/template/PageContainer';
import { useSessionUser } from '@/store/authStore.ts';
import AppRoute from './AppRoute';
import AuthorityGuard from './AuthorityGuard';
import ProtectedRoute from './ProtectedRoute';
import PublicRoute from './PublicRoute';

const { authenticatedEntryPath } = appConfig;

const AllRoutes = () => {
  const userAuthority = useSessionUser((state) => state.user?.role) ?? null;

  return (
    <Routes>
      <Route path="/" element={<ProtectedRoute />}>
        <Route path="/" element={<Navigate replace to={authenticatedEntryPath} />} />
        {protectedRoutes.map((route, index) => (
          <Route
            key={route.key + index}
            path={route.path}
            element={
              <AuthorityGuard userAuthority={userAuthority} authority={route.authority}>
                <PageContainer {...route.meta}>
                  <AppRoute routeKey={route.key} component={route.component} {...route.meta} />
                </PageContainer>
              </AuthorityGuard>
            }
          />
        ))}
        <Route path="*" element={<Navigate replace to="/" />} />
      </Route>
      <Route path="/" element={<PublicRoute />}>
        {publicRoutes.map((route) => (
          <Route
            key={route.path}
            path={route.path}
            element={<AppRoute routeKey={route.key} component={route.component} {...route.meta} />}
          />
        ))}
      </Route>
    </Routes>
  );
};

export default AllRoutes;
